import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
    return (
        <a
            data-testid="whatsapp-float"
            href="https://wa.me/919249899999?text=Hi%20Midasis%20Elite%2C%20I%27d%20like%20to%20discuss%20a%20project."
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-2xl flex items-center justify-center play-pulse transition-colors"
            style={{ boxShadow: "0 12px 28px rgba(37, 211, 102, 0.35)" }}
        >
            <MessageCircle size={26} />
        </a>
    );
}
